import { toast } from "sonner";

/**
 * Centralized error handling for chat functionality
 */
export const handleChatError = (error: any, operation: string) => {
  console.error(`Chat ${operation} error:`, error);
  
  // Handle specific error types
  if (error?.code === 'PGRST301') {
    toast.error("Je hebt geen toegang tot deze chat functie");
    return;
  }
  
  if (error?.code === 'PGRST116') {
    toast.error("Chat bericht niet gevonden");
    return;
  }
  
  if (error?.message?.includes('permission denied') || error?.message?.includes('row-level security policy')) {
    toast.error("Authenticatie probleem. Probeer opnieuw in te loggen.", {
      description: "Je sessie is mogelijk verlopen of er is een probleem met je rechten."
    });
    return;
  }
  
  if (error?.message?.includes('Geen geldige gebruikers ID')) {
    toast.error("Sessie probleem. Log opnieuw in.", {
      description: "Je gebruikers ID kon niet worden opgehaald."
    });
    return;
  }
  
  if (error?.message?.includes('network')) {
    toast.error("Netwerkfout. Probeer het opnieuw.");
    return;
  }
  
  // Generic error message
  const errorMessages = {
    'send': 'Kon bericht niet verzenden',
    'edit': 'Kon bericht niet bewerken', 
    'delete': 'Kon bericht niet verwijderen',
    'load': 'Kon berichten niet laden',
    'status': 'Kon status niet bijwerken'
  };
  
  const message = errorMessages[operation as keyof typeof errorMessages] || 'Er is een fout opgetreden';
  toast.error(message, { 
    description: error?.message || 'Onbekende fout'
  });
};